import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

import { ErrorToast } from "core/utils/show-toast";
import { getAccessToken } from "../auth/auth";


axios.interceptors.request.use(
  async (config: AxiosRequestConfig) => {
    const token = await getAccessToken();

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);



axios.interceptors.response.use(
  (response: AxiosResponse): AxiosResponse => {
    return response;
  },
  (error: any) => {
    const {
      response: { status, data },
      config: originalRequest,
      code,
    } = error;

    const errorMessage = data?.messages || [];
    const helperMessage = data?.helperMessage || [];

    // Handle 401 Unauthorized
    if (status === 401) {
      if (!originalRequest._retry) {
        originalRequest._retry = true;
        return axios(originalRequest);
      }
     window.location.pathname = "/signout-oidc";
      return;
    }
    // Handle 404 Not Found
    if (status === 404 && !data) {
      ErrorToast(["مشکلی پیش آمده است!"]);
      return;
    }
    // General error handling
    const expectedError: boolean = status >= 400 && status < 500;
    const messages = expectedError
      ? [...errorMessage, ...helperMessage]
      : [`مشکلی پیش آمده است!`];
    ErrorToast(messages);

    return Promise.reject({
      status: status,
      message: errorMessage,
      helperMessage: helperMessage,
    });
  }
);

const methods = {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
};

export default methods;
